import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  AutomobilesStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { requiredFileIf } from '../../useValidateQuestionnaire';

export const fields: IBaseField<keyof AutomobilesStateValues | any>[] = [
  {
    name: 'didYouUseAnAutomobileForYourBusinessThisYear',
    label: 'Did you use an automobile for your business this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,

    dependencies: [
      {
        name: 'automobileList',
        label: 'Automobile List',
        type: 'fieldArray',
        predicate: (v) => v === 'yes',
        dependencies: [
          {
            name: 'isThisVehicleRegisteredInTheNameOfTheBusinessOrAPersonalName',
            label:
              'Is this vehicle registered in the name of the business or a personal name?',
            type: 'select',
            options: [
              {
                label: 'Personal',
                value: 'Personal',
              },
              {
                label: 'Business',
                value: 'Business',
              },
            ],
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'didYouMaintainAMileageLogThisYear',
                label: 'Did you maintain a mileage log this year?',
                type: 'radio',
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'Personal',
                dependencies: [
                  {
                    name: 'pleaseUploadCopyOfMileageLog',
                    label: 'Please upload copy of Mileage Log.',
                    type: 'upload',
                    effect: updateKeyInStore(updateKey),
                    predicate: (v) => v === 'yes',
                  },
                ],
              },
            ],
          },

          {
            name: 'makeOfTheVehicleYouUsedForYourBusinessOrTravel',
            label: 'Make of the vehicle you used for your business, or travel',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'modelOfTheVehicleYouUsedForYourBusinessOrTravel',
            label: 'Model of the vehicle you used for your business, or travel',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'yearOfTheVehicleYouUsedForYourBusinessOrTravel',
            label: 'Year of the vehicle you used for your business, or travel',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'whatDateDidYouStartUsingThisVehicleForBusiness',
            label: 'What date did you start using this vehicle for business',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'odometerReadingAtTheBeginningOfLastYear01012020',
            label:
              'Odometer reading at the beginning of last year (01/01/{year})',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'odometerReadingAtTheEndOfLastYear12312020',
            label: 'Odometer reading at the end of last year (12/31/{year})',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'totalMilesDrivenDuringTheYear',
            label: 'Total miles driven during the year',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'howManyMilesDidYouDriveStrictlyForBusiness',
            label: 'How many miles did you drive strictly for business?',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'howManyMilesDidYouCommuteDuring2020',
            label: 'How many miles did you commute during 2020?',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'howManyMilesIsItFromYourHomeToWork',
            label: 'How many miles is it from your home to work?',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'howManyMilesDidYouDriveForPersonalUse',
            label: 'How many miles did you drive for personal use?',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'doYouOwnOrLeaseTheVehicle',
            label: 'Do you own or lease the vehicle?',
            type: 'select',
            options: [
              {
                label: 'Own',
                value: 'Own',
              },
              {
                label: 'Lease',
                value: 'Lease',
              },
            ],
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'purchaseDate',
                label: 'Purchase Date',
                type: 'date',
                effect: updateKeyInStore(updateKey),
                tooltip: 'Displayed in case the user selects "Own"',

                predicate: (v) => v === 'Own',
              },
              {
                name: 'purchasePrice',
                label: 'Purchase Price',
                type: 'number',
                effect: updateKeyInStore(updateKey),
                tooltip: 'Displayed in case the user selects "Own"',
                predicate: (v) => v === 'Own',

                comment: true,
              },
              {
                name: 'didYouUseTheStandardMileageRateOrTheExpensedepreciationMethodLastYear',
                label:
                  'Did you use the Standard Mileage Rate or the Expense/Depreciation method last year?',
                type: 'select',
                options: [
                  {
                    label: 'Standard Mileage Rate',
                    value: 'Standard Mileage Rate',
                  },
                  {
                    label: 'Expense/Depreciation',
                    value: 'Expense/Depreciation',
                  },
                ],
                effect: updateKeyInStore(updateKey),
                predicate: (v) => v === 'Own',
                tooltip: 'Displayed in case the user selects "Own"',
                comment: true,

                dependencies: [
                  {
                    name: 'fueloilserviceCosts',
                    label: 'Fuel/Oil/Service Costs',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'insuranceRegistration',
                    label: 'Insurance & Registration',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'repairsreplacementstiresbatteries',
                    label: 'Repairs/Replacements (Tires/Batteries)',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'careMaintenance',
                    label: 'Care & Maintenance',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'otherExpenses',
                    label: 'Other Expenses',
                    type: 'number',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'doYouHaveALog',
                    label: 'Do you have a log?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'doYouHaveReceipts',
                    label: 'Do you have receipts?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'wereYouReimbursedByYourEmployer',
                    label: 'Were you reimbursed by your employer?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'didYouPayForParking',
                    label: 'Did you pay for parking?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                  },
                  {
                    name: 'doYouHaveAnotherVehicleAvailableToYouForPersonalUse',
                    label:
                      'Do you have another vehicle available to you for personal use?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    tooltip:
                      'Displayed in case the user selects "Expense/Depreciation"',
                    comment: true,
                    predicate: (v) => v === 'Expense/Depreciation',
                    dependencies: [
                      {
                        name: 'isThisVehicleAvailableDuringNonWorkingHours',
                        label:
                          'Is this vehicle available during non-working hours?',
                        type: 'radio',
                        effect: updateKeyInStore(updateKey),
                        tooltip:
                          'Displayed in case the user selects yes to the previous question',
                        comment: true,
                        predicate: (v) => v === 'yes',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        tooltip: '',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  automobileList: Yup.array(
    Yup.object({
      pleaseUploadCopyOfMileageLog: requiredFileIf(
        'didYouMaintainAMileageLogThisYear',
        'yes',
      ),
    }),
  ),
});
